import { render, staticRenderFns } from "./CategoryDelete.vue?vue&type=template&id=02fad2be&"
import script from "./CategoryDelete.vue?vue&type=script&lang=js&"
export * from "./CategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports